import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  HostListener,
  ElementRef,
  ContentChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-alert-icon',
  templateUrl: './alert-icon.component.html',
  styleUrls: ['./alert-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertIconComponent implements OnInit {
  @Input() alert: boolean = true;
  @Input() isVariant?: boolean = false;
  @Input() link: string = '';

  @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();

  isOpened: boolean = false;

  @ContentChild('button', { static: true }) button!: ButtonComponent;

  constructor(private _elementRef: ElementRef) {}

  ngOnInit(): void {}

  redirectTo() {
    if (this.link) {
      // this._router.navigateByUrl(`private-office/tariffs-and-payment`);
    }
    if (this.isVariant) {
      this.buttonClick.emit();
    }
    this.isOpened = false;
  }

  @HostListener('document:click', ['$event.target'])
  outsideClick(targetElement: Node | null): void {
    if (this.isOpened && !this._elementRef.nativeElement.contains(targetElement)) {
      this.isOpened = false;
    }
  }

  @HostListener('mouseenter', ['$event']) onMouseEnter(event: any) {
    if (this.alert) {
      this.isOpened = true;
    }
  }

  @HostListener('click', ['$event']) onMouseClick(event: any) {
    if (!this.alert) {
      this.button?.elementRef?.nativeElement.click();
    }
  }

  @HostListener('mouseleave', ['$event']) onMouseLeave(event: any) {
    this.isOpened = false;
  }
}
